import { useContext } from "react";

import { DocumentsContext } from "@Console/statement/context/DocumentsContext";

export const useDocumentsContext = () => useContext(DocumentsContext);
